import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './shared/header/header.component';
import { FooterComponent } from './shared/footer/footer.component';
import { ThemeService } from './core/theme.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent],
  template: `
    <app-header />
    <main class="main-content">
      <router-outlet />
    </main>
    <app-footer />
  `,
  styles: [`
    :host {
      display: flex;
      flex-direction: column;
      min-height: 100vh;
    }
    .main-content {
      /*
       * Keep top spacing equal to the fixed header height so routed pages start
       * exactly below the toolbar. Other page paddings stay component-controlled.
       */
      flex: 1;
      max-width: 1400px;
      margin: 0 auto;
      width: 100%;
      padding-top: 64px;
    }

    @media (max-width: 600px) {
      .main-content {
        padding-top: 56px;
      }
    }
  `]
})
export class AppComponent {
  constructor(
    private themeService: ThemeService,
  ) {
    void this.themeService.initFromUserProfile();
  }
}
